<template>
    <van-popup class="share-change-group-popup other-share-change-group-popup" v-bind:value="showDiscussSavePop" @click-overlay='clickOverlay'>
        <div class="share-cgpp-title">{{setting.title}}</div>
        <div class="share-cgpp-item">
            <label class="collate-form-label">{{setting.label1}}</label>
            <input class="collate-form-input" type="text" maxlength="15" v-bind:placeholder="setting.placehold1" v-model="discussFormData.f_name" autofocus>
        </div>
        <div class="share-cgpp-item" @click="chooseGroup">
            <label class="collate-form-label">{{setting.label2}}</label>
            <div class="share-cgpp-choose">
                <span v-if="discussFormData.group && discussFormData.group != ''" class="share-cgpp-text-have">{{discussFormData.group.slice(0, 10)}}</span>
                <span v-else class="share-cgpp-text">选择分组</span>
                <i class="cf-icon-right iconfont icon-xiangyou"></i>
            </div>
        </div>
        <div class="share-cgpp-item">
            <label class='collate-form-label'>{{setting.label3}}</label>
            <input class="collate-form-input" type="text" maxlength="15" v-bind:placeholder="setting.placehold2" v-model="discussFormData.shareTitle">
        </div>
        <div class="share-cgpp-button" @click="confirmChange">{{setting.saveText}}</div>
    </van-popup>
</template>

<script>
export default {
    name: 'VantDiscussSavePop',
    computed: {
        showDiscussSavePop() {
            return this.$store.state.discuss.showDiscussSavePop;
        },
        discussFormData() {
            return this.$store.state.discuss.discussFormData;
        }
    },
    data() {
        return {
            setting: {
                title: '确定新八字名称、分组及论盘主题',
                label1: '八字名称',
                label2: '八字分组',
                label3: '论盘主题',
                placehold1: '输入八字名称',
                placehold2: '输入论盘主题',
                saveText: '确定并进入论盘'
            },
            confirmLock: false
        }
    },
    methods: {
        clickOverlay() {
            this.$store.state.discuss.showDiscussSavePop = false;
        },
        chooseGroup() {
            var curpath = this.$router.history.current.path;
                curpath = curpath + '/choosegroup';
            this.$router.push({ path: curpath });
        },
        confirmChange() {
            // 校验值
            console.log('confirmChange-----', this.discussFormData)
            if(this.confirmLock) {
                return;
            }
            this.confirmLock = true;
            if(this.discussFormData.f_name == '') {
                this.$toast('八字名称不能为空');
                return;
            }
            if(this.discussFormData.shareTitle == '') {
                this.$toast('论盘名称不能为空');
                return;
            }
            var me = this;
            this.$store.dispatch('discuss/saveNewPaipanLunpan', {
                cb: function(){
                    me.confirmLock = false;
                }
            });
        }
    }
}
</script>